const responseContext = {
    statusCode: 200
};

export default responseContext;